import classNames from "classnames";
import { IonChip } from "@ionic/react";

const FilterPill: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const { active, name, count, isMobile } = props;
  return isMobile ? (
    <IonChip onClick={props.onClick} color={active ? undefined : "medium"}>
      {name}
    </IonChip>
  ) : (
    <div
      className={classNames("visito-card", "visito-block", "actionable", {
        active: active,
      })}
      onClick={props.onClick}
    >
      <div className={`visito-card-body`}>
        <div className="">{name}</div>
        <div className="fw-semibold-1">
          {Intl.NumberFormat("en-US").format(count || 0)}
        </div>
      </div>
    </div>
  );
};

interface ILayoutProps {
  active: boolean;
  name: string;
  count?: number;
  onClick?: () => void;
  isMobile: boolean;
  //passThrough: () => void;
}

export default FilterPill;
